import type { FC } from "react";
import React from "react";

import { ButtonCellActionDefaultPreset } from "../../helpers/ButtonCellActionDefaultPreset";

import type { ButtonCellActionPresetProps } from "../../types";

export const ButtonCellActionBlock: FC<ButtonCellActionPresetProps> = (
    props,
) => {
    return (
        <ButtonCellActionDefaultPreset
            {...props}
            view="destructive"
            icon="glyph_block_24+"
        />
    );
};

ButtonCellActionBlock.displayName = "ButtonCellActionBlock";
